import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '@auth/auth.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-impersonation-banner',
  templateUrl: './impersonation-banner.component.html',
  styleUrls: ['./impersonation-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule],
})
export class ImpersonationBannerComponent {
  // Use observables from AuthService for reactive UI updates
  isImpersonating$: Observable<boolean>;
  impersonatorInfo$: Observable<{ username: string; userId: number } | null>;
  impersonatedUserInfo$: Observable<{ username: string; userId: number } | null>;

  constructor(private authService: AuthService) {
    this.isImpersonating$ = this.authService.isImpersonating$;
    this.impersonatorInfo$ = this.authService.impersonatorInfo$;
    this.impersonatedUserInfo$ = this.authService.impersonatedUserInfo$;
  }

  stopImpersonating(): void {
    this.authService.stopImpersonation();
  }
}
